import { PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CreateButtonProps {
  label?: string;
  onClick: () => void;
}

export function LinkButton({ label, onClick }: CreateButtonProps) {
  return (
    <Button size="sm" onClick={onClick}>
      <PlusCircle /> New {label}
    </Button>
  );
}
